import { render, staticRenderFns } from "./seguimientoTicket.vue?vue&type=template&id=318bde3b"
import script from "./seguimientoTicket.vue?vue&type=script&lang=js"
export * from "./seguimientoTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports